import React from 'react';
import MuiSelect from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
// import { makeStyles } from "@material-ui/core/styles";
// import expandIcon from '../../assets/chevron-pull.svg';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


export default function SelectInput({ props }) {
  const { id, value, handleChange, errors, helperText, options, width = '100%', height, disableUnderline = false, isMobile = false, inputProps = {}, onClose= () => {}, disabled = false } = props;

  return (
    <MuiSelect
      value={value}
      onChange={(event) => handleChange(id, event)}
      style={{ width: width, height: height }}
      error={!!errors}
      helperText={errors && helperText}
      sx={{
        '.Mui-error': {
          color: 'red'
        },
        '& .MuiSvgIcon-root': {
          fontSize: '1.75em'
        },
        borderRadius: 0,
        boxShadow: 'none', 
        '.MuiOutlinedInput-notchedOutline': { border: '0 !important' },
        '& .MuiMenu-list': {
          padding: '0px !important'
        },
        fontSize: '14px',
        fontFamily: 'inherit !important',
        backgroundColor: '#f6f6f6'
      }}
      inputProps={inputProps}
      onClose={onClose}
      MenuProps={{
        sx: {
          '& .MuiMenu-list': {
            padding: '0px !important'
          },
        },
        PaperProps: {
          style: {
            minHeight: 72,
            maxHeight: 352
          },
        },
      }}
      disableUnderline={disableUnderline}
      IconComponent={KeyboardArrowDownIcon}
      disabled={disabled}
    >
      {options.map((option) => (
        <MenuItem sx={{ 
          backgroundColor: '#f6f6f6 !important',
          // '& .Mui-selected': {
          //   backgroundColor: '#f6f6f6'
          // },
          '&:hover': {
            backgroundColor: '#04327A !important',
            color: 'white !important'
          },
          height: '64px'
           }} key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </MuiSelect>
  );
}